import React from 'react';
// import Header from './Header';
// import Footer from './Footer';

const MyContact2 = () => {
  return (
    <>
      {/* <Header /> */}
      {/* <div className="breadcumb-wrapper" data-bg-src="assets/img/bg/breadcumb-bg.jpg">
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Contact info2</h1>
          </div>
        </div>
      </div> */}


      <div
        className="breadcumb-wrapper"
        style={{ backgroundImage: `url('assets/img/bg/breadcumb-bg.jpg')`, backgroundPosition: 'center', backgroundSize: 'cover' }}
      >
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Contact info</h1>
          </div>
        </div>
      </div>

      <div className="space">
        <div className="container">
          <div className="row gy-4">
            <div className="col-xl-4 col-lg-6">
              <div className="contact-media">
                <div className="icon-btn">
                  <i className="fa-solid fa-location-dot"></i>
                </div>
                <div className="media-body">
                  <h5 className="box-title">Sreemath Hariharapura Address</h5>
                  <p className="box-text">
                    Hariharapura, Chikmagalur district, Karnataka, India - 577120
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6">
              <div className="contact-media">
                <div className="icon-btn">
                  <i className="fa-solid fa-phone-volume"></i>
                </div>
                <div className="media-body">
                  <h5 className="box-title">Office Phone Number</h5>
                  <p className="box-text" style={{ margin: 0 }}>
                    <a href="tel:+919019977466" style={{ display: 'block', lineHeight: '1.6' }}>+91 901 997 7466</a>
                    <span style={{ display: 'block', fontSize: '13px', marginTop: '6px', color: '#555', lineHeight: '1.5' }}>
                      For Homas kindly requested to contact <a href="tel:+919364798483" style={{ color: 'inherit', fontWeight: 'bold' }}>+91 93647 98483</a>
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6">
              <div className="contact-media">
                <div className="icon-btn">
                  <i className="fa-solid fa-envelope"></i>
                </div>
                <div className="media-body">
                  <h5 className="box-title">Guest House</h5>
                  <p className="box-text" style={{ display: 'flex', flexDirection: 'column', gap: '4px', margin: 0 }}>
                    <a href="tel:+919364798485" style={{ display: 'inline-block', lineHeight: '1.2' }}>+91 93647 98485</a>
                    <a href="tel:+919481830694" style={{ display: 'inline-block', lineHeight: '1.2' }}>+91 94818 30694</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row gy-4 mt-5">
            <div className="col-xl-4 col-lg-6">
              <div className="contact-media">
                <div className="icon-btn">
                  <i className="fa-solid fa-location-dot"></i>
                </div>
                <div className="media-body">
                  <h5 className="box-title">Sreemath Bangalore Branch</h5>
                  <p className="box-text">
                    1370/M, Nehru Road, 1st phase Girinagar, Bengaluru, Karnataka
                    560085
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6">
              <div className="contact-media">
                <div className="icon-btn">
                  <i className="fa-solid fa-phone-volume"></i>
                </div>
                <div className="media-body">
                  <h5 className="box-title">Phone Number</h5>
                  <p className="box-text">
                    <a href="tel:080-26426116">080-26426116</a>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6">
              <div className="contact-media">
                <div className="icon-btn">
                  <i className="fa-solid fa-envelope"></i>
                </div>
                <div className="media-body">
                  <h5 className="box-title">Email Address</h5>
                  <p className="box-text">
                    <a href="mailto:hhpuraoff@gmail.com">hhpuraoff@gmail.com</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="">
        <div className="contact-map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3879.2031010822607!2d75.300255!3d13.523124!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbb6b0272431d27%3A0x9a1ca9514d83c15b!2sShri%20Adi%20Shankaracharya%20Sharada%20Lakshminarasimha%20Peta%20(Shri%20Matha%20Hariharapura)!5e0!3m2!1sen!2sin!4v1758796003188!5m2!1sen!2sin"
            width="100%" height="450" style={{ border: 0 }} allowFullScreen="" loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
      <div className="about-area overflow-hidden space" id="about-sec">
        <div className="container">
          <div className="row gy-5">
            <div className="col-xl-4">
              <div className="about-feature style4 wow fadeInUp" data-wow-delay=".4s">
                <div className="box-icon">
                  <img src="assets/img/contact/air.png" alt="Icon" />
                </div>
                <div className="media-body">
                  <h3 className="box-title">By Air</h3>
                  <p className="box-text">
                    The closest major airports are Bangalore, Mangalore and
                    Shivmoga. Divyakshetra Hariharapura is reachable by road from both these
                    airports.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-4">
              <div className="about-feature style4 wow fadeInUp" data-wow-delay=".4s">
                <div className="box-icon">
                  <img src="assets/img/contact/road.png" alt="Icon" />
                </div>
                <div className="media-body">
                  <h3 className="box-title">By Road</h3>
                  <p className="box-text">
                    Bangalore is about 280 Kms and Mangalore is about 125 Kms from Divyakshetra
                    Hariharapura. Buses, private or state, run day and night with
                    regular frequency from both these cities. There are also night
                    sleeper buses operating from Bangalore to Hariharapura.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xl-4">
              <div className="about-feature style4 wow fadeInUp" data-wow-delay=".5s">
                <div className="box-icon">
                  <img src="assets/img/contact/train.png" alt="Icon" />
                </div>
                <div className="media-body">
                  <h3 className="box-title">By Train</h3>
                  <p className="box-text">
                    Disembark at Shimoga if traveling from Bangalore. It’s a
                    3-hour bus trip from there. Disembark at Udupi or Mangalore by
                    Konkan Rail, if traveling from Mumbai. It’s again a 3-hour
                    drive from these cities.
                  </p>
                </div>
              </div>
            </div>
            <p>
              <strong>Places close by:</strong>
              <br />
              The famous pilgrim centres of Sringeri and Shakatapura are at 20 Kms
              and 8 Kms distance from Divyakshetra Hariharapura. From Koppa, it takes barely 15
              mins to reach Hariharapura.
            </p>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default MyContact2;
